module.exports = __webpack_public_path__ + "img/1524547179.eb7fc2c4.jpg";